<template>
  <div>
    <div class="ant-page-header-tl">
      <img class="avatar" :src="avatar" alt="" />
      <span style="margin: 0 16px">{{ username }}</span>

      <a-tree-select
          show-search
          style="width: 245px"
          v-model="selectDefault"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          placeholder=""
          allow-clear
          tree-default-expand-all
          @change="onTreeChange"
      >
        <a-tree-select-node :selectable="false" v-for="(item) in applyList" :key="item.id" :value="item.id" :title="item.name">
          <a-tree-select-node v-for="(sonitem) in item.son" :key="sonitem.id" :value="sonitem.id" :title="sonitem.name">
          </a-tree-select-node>
        </a-tree-select-node>
      </a-tree-select>
      <a-button
          @click="addInvioce"
          style="margin-left: 16px"
          type="primary"
      >新增报销单</a-button
      >
      <a-button style="float: right" v-print="'#printBtn'">打印</a-button>

    </div>
    <div class="empty" v-if="serialList.length==0">
      <a-empty description="还没有报销单，创建一个" />
    </div>
    <a-spin :spinning="spinning" size="small" v-else>
      <div class="boxwrapper">
        <a-button class="submitbtn" type="primary" @click="bindSubmit">提交报销单</a-button>

        <div id="printBtn" style="width: 835px; margin: 0 auto">
          <div class="box-num">
            <span style="width: 102px; text-align: center; color: #000"
            >序号 No.</span
            >
            <a-select
                v-model="serialKey"
                style="width: 140px;"
                :show-arrow="false"
                @change="serialChange"
                show-search
                placeholder=""
            >
              <a-select-option
                  v-for="(item, index) in serialList"
                  :key="index"
                  :value="item.serial"
              >{{ item.serial }}</a-select-option
              >
            </a-select>
            <!-- <span style="color: #000">{{ invoiceKey }}

            </span> -->
          </div>
          <div class="box-lartl">北京金泰伦技术服务有限公司</div>
          <div class="box-tl">员工费用报销申请单</div>
          <div class="table">
            <div class="tr ttop">
              <span class="td" style="width: 101px; font-weight: bold"
              >申请人</span
              >
              <span class="td" style="width: 101px; font-weight: bold">{{
                  username
                }}</span>
              <span class="td" style="width: 101px; font-weight: bold">
                报销类型
              </span>
              <span class="td" style="width: 264px;">{{applyType}}</span>
              <span class="td" style="width: 163px; font-weight: bold"
              >申请时间</span
              >
              <span class="td" style="flex: 1; justify-content: flex-end">{{
                  dateString
                }}</span>
            </div>
            <div class="theader">
              <span class="td" style="width: 101px">序号</span>
              <span class="td" style="width: 101px"
              >交易日期 <br />(YY-MM-DD)</span
              >
              <span class="td" style="width: 101px">发票类型</span>
              <!-- <span class="td" style="width: 101px">报销类型</span> -->
              <span class="td" style="width: 427px">费用说明</span>
              <!-- <span class="td" style="width: 124px">发票号码</span> -->
              <span class="td" style="flex: 1">金额</span>
            </div>
            <div class="tr" v-for="(item, index) in dataList" :key="index">
              <span class="td" style="width: 101px; font-size: 12px">{{
                  index + 1
                }}</span>
              <span
                  class="td"
                  style="
                  justify-content: flex-start;
                  width: 101px;
                  font-size: 12px;
                "
              >
                <!-- {{ item.transdate }} -->
                <a-date-picker
                    v-model="item.transdate"
                    :allowClear="false"
                    placeholder=""
                    @change="(date, dateString) => dataPickerChange(date, dateString, index)"
                />
              </span>
              <!-- <span
              class="td"
              style="justify-content: flex-start; width: 101px"
              >{{ item.type }}</span
            > -->
              <span
                  class="td"
                  style="justify-content: flex-start; width: 101px"
              >
                <a-select
                    v-model="item.type"
                    style="width: 100%"
                    @change="handleTypeChange"
                    :show-arrow="false"
                    show-search
                    placeholder=""
                >
                  <a-select-option
                      v-for="(item, index) in typeList"
                      :key="index"
                      :value="item.id"
                  >{{ item.name }}</a-select-option
                  >
                </a-select>
                <!-- {{ item.apply }} -->
              </span>

              <span
                  class="td"
                  style="justify-content: flex-start; width: 427px"
              >
                <!-- {{ item.expdes }} -->
                <a-input v-model="item.expdes" style="width: 100%" />
              </span>
              <!-- <span class="td" style="width: 124px; font-size: 12px">{{
              item.number
            }}</span> -->
              <span
                  class="td"
                  style="justify-content: flex-end; flex: 1; font-size: 12px"
              >
                <a-input
                    v-model="item.amount"
                    style="width: 100%; text-align: right"
                    @blur="() => amoutBlur(item.amount, index)"
                />


                <!-- {{ item.amount }} -->
              </span>
              <!-- <span class="close" @click="deleteItem(item.id)"
              ><a-icon type="close"
            /></span> -->
            </div>
            <div class="tr">
              <span
                  class="td"
                  style="width: 730px; font-weight: bold; font-size: 14px"
              >合计</span
              >
              <span
                  class="td"
                  style="
                  flex: 1;
                  justify-content: flex-end;
                  font-weight: bold;
                  font-size: 14px;
                  color: #000;
                "
              >{{ total }}</span
              >
            </div>
          </div>
          <div class="tbottom">
            <div
                style="
                width: 101px;
                margin-right: 303px;
                border-top: 1px solid #000;
              "
            >
              <span class="tbottom-text">编制</span>
              <span class="tbottom-text">日期:</span>
            </div>
            <div
                style="
                width: 101px;
                margin-right: 225px;
                border-top: 1px solid #000;
              "
            >
              <span class="tbottom-text">审批</span>
              <span class="tbottom-text">日期:</span>
            </div>
            <div style="flex: 1; border-top: 1px solid #000">
              <span class="tbottom-text">核查</span>
              <span class="tbottom-text">日期:</span>
            </div>
          </div>
        </div>

        <div class="tips">
          <h4 style="color: #666">发票类型说明：</h4>
          <p>1. <b>餐费：</b>聚餐，下午茶等</p>
          <p>2. <b>交通费：</b>日常的打车费</p>
          <p>3. <b>培训费：</b>培训相关费用</p>
          <p>
            4.
            <b>办公用品：</b
            >采购电脑，书本，硬盘，打印纸，鼠标键盘等日常办公所需产品
          </p>
          <p>5. <b>食品：</b>采购蔬菜，水果，零食，蛋糕，饮料等食用的东西</p>
          <p>
            6. <b>服务费：</b>平台服务费，技术服务费，财务服务费等其他第三方服务费
          </p>
        </div>
      </div>
    </a-spin>


  </div>
</template>
<script>
import api from "@/common/api.js";
import moment from "moment";
// let dataList = [
//   {
//     id: 1,
//   },
//   {
//     id: 2,
//   },
//   {
//     id: 3,
//   },
//   {
//     id: 4,
//   },
//   {
//     id: 5,
//   },
//   {
//     id: 6,
//   },
//   {
//     id: 7,
//   },
//   {
//     id: 8,
//   },
//   {
//     id: 9,
//   },
//   {
//     id: 10,
//   },
//   {
//     id: 11,
//   },
//   {
//     id: 12,
//   },
//   {
//     id: 13,
//   },
//   {
//     id: 14,
//   },
//   {
//     id: 15,
//   },
//   {
//     id: 16,
//   },
//   {
//     id: 17,
//   },
//   {
//     id: 18,
//   },
//   {
//     id: 19,
//   },
//   {
//     id: 20,
//   },
//   {
//     id: 21,
//   },
//   {
//     id: 22,
//   },
// ];
export default {
  data() {
    return {
      treeExpandedKeys: [],
      moment,
      expdes: "",
      type: "",
      typeId: 0,
      typeList: [],
      number: "",
      amount: "",
      loading: false,
      transdate: moment()
      .startOf("day")
      .subtract(0, "days")
      .format()
      .slice(0, 10),
      dateString: moment()
      .startOf("day")
      .subtract(0, "days")
      .format()
      .slice(0, 10),
      dataList: [],//表格数据
      spinning: false,
      email: "",
      username: "wangfujuan",
      avatar: "",
      apply: "",
      applyList: [], //报销类型列表
      applyType: '', //报销类型
      total: 0, //总金额
      applyId: "",
      serialList: [], //序号列表
      serialKey: 0,
      selectDefault: ''
    };
  },
  methods: {
    onTreeChange(e){
      console.log(e);
      this.serialKey = e;
    },
    //日期更改
    dataPickerChange(date, dateString, index){
      this.dataList[index].transdate = dateString;
    },
    // 金额改变
    amoutBlur(amount, index){
      let amountList = parseFloat(amount).toFixed(2).split(".");
      if(amountList == 'NaN') {
        amountList = ['0','00']
      }
      this.dataList[index].amount = amountList[0].replace(/(\d)(?=(?:\d{3})+$)/g,'$1,') + '.' +amountList[1];
      let total = 0;
      this.dataList.forEach((item) => {
        let amount = item.amount.replace(/,/g, '');
        if(amount){
          total += parseFloat(amount);
        }
      })
      let totalList = total.toFixed(2).split(".");
      this.total = totalList[0].replace(/(\d)(?=(?:\d{3})+$)/g,'$1,') + '.'+totalList[1];
    },
    //序号改变
    serialChange(e){
      this.serialKey = e;
      this.getList();
    },
    deleteItem(id) {
      this.spinning = true;
      console.log(id);
      this.$post(api.tool.del_invoice, {
        email: this.email,
        invoice_id: id,
      }).then((res) => {
        if (res.code === 200) {
          this.spinning = false;
          this.$message.success(res.msg);
          this.getList();
        }
      });
    },
    addInvioce() {
      if(this.serialKey){
        this.$post(api.tool.addserial, {
          tid: this.serialKey,
          email: this.email,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success(res.msg);
            this.getSeriallist();
            this.getList();
          }
        });
      }else{
        this.$message.error('请先选择发票类型');
      }

    },
    handleTypeChange(e) {
      this.typeId = e;
    },
    handleApplyChange(e) {
      this.applyId = e;
    },
    getApplyList() {
      this.$post(api.tool.apply_type, {}).then((res) => {
        if (res.code === 200) {
          this.applyList = res.list;
        }
      });
    },
    getTypeList() {
      this.$post(api.tool.invoice_type, {}).then((res) => {
        if (res.code === 200) {
          this.typeList = res.list;
          this.type = res.list[0].name;
          this.typeId = res.list[0].id;
        }
      });
    },
    getSeriallist() {
      this.$post(api.tool.seriallist, {
        email: this.email,
      }).then((res) => {
        if (res.code === 200) {
          this.serialList = res.list;
          console.log(this.serialList.length);
          if(this.serialList.length){
            this.serialKey = res.list[0].serial;
            this.getList();
          }
        }
      });
    },
    getList() {
      this.spinning = true;
      this.$post(api.tool.getinvoice, {
        email: this.email,
        serial_id: this.serialKey,
      }).then((res) => {
        if (res.code === 200) {
          this.spinning = false;
          this.dataList = res.list.invoice;
          console.log( this.dataList)
          let total = 0;
          this.selectDefault = res.list.apply_type;
          this.dataList.forEach(item => {
            total = total + Number(item.amount);
            if(item.amount){
              let amountList = parseFloat(item.amount).toFixed(2).split(".");
              item.amount = amountList[0].replace(/(\d)(?=(?:\d{3})+$)/g,'$1,') + '.' +amountList[1];
            }
          })
          let totalList = total.toFixed(2).split(".");
          this.total = totalList[0].replace(/(\d)(?=(?:\d{3})+$)/g,'$1,') + '.'+totalList[1];
          this.applyType = res.list.apply_type;
        }
      });
    },
    bindSubmit() {
      this.loading = true;
      this.$post(api.tool.addinvoice, {
        email: this.email,
        serial_id: this.serialKey,
        list: this.dataList,
      }).then((res) => {
        this.loading = false;
        if (res.code === 200) {
          this.getList();
          this.$message.success(res.msg);
          this.expdes = "";
          this.number = "";
          this.amount = "";
        }
      });
    },
  },
  created() {
    if (localStorage.impr_email) {
      this.getApplyList();
      this.getTypeList();
      this.email = localStorage.impr_email;
      this.username = localStorage.impr_name;
      this.avatar = localStorage.impr_picture;
      this.getSeriallist();

    } else {
      this.$router.push({ path: "/login" });
    }
  },
};
</script>
<style>
.boxwrapper{
  position: relative;
  width: 835px;
  margin: 0 auto;
}
.submitbtn{
  position: absolute;
  right: 0;
  z-index: 99;
}
.content,
.tips {
  width: 835px;
  margin: 32px auto;
}
.edit-item {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.edit-title {
  font-weight: bold;
  width: 102px;
  flex: 0 0 102px;
  text-align: right;
  padding-right: 16px;
}
.edit-btn {
  margin-left: 102px;
}
.table {
  margin-top: 24px;
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;
}
.tr {
  display: flex;
  width: 100%;
  position: relative;
}
.td {
  border-left: 1px solid #000;
  border-top: 1px solid #000;
  height: 32px;
  padding: 0 8px;
  font-size: 13px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.theader {
  display: flex;
  width: 100%;
  height: 60px;
  justify-content: flex-end;
}
.theader .td {
  height: 60px;
  line-height: 1.2;
  text-align: center;
  font-weight: bold;
}
.ttop .td {
  height: 35px;
}
.box-tl {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
.box-lartl {
  color: #000;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 24px;
}
.box-num {
  margin-top: 48px;
  display: flex;
  font-size: 18px;
  line-height: 32px;
}
.tbottom {
  margin-top: 60px;
  display: flex;
}
.tbottom-text {
  font-size: 14px;
  font-weight: bold;
  display: block;
  color: #000;
  padding-left: 3px;
}
.close {
  position: absolute;
  display: block;
  right: -32px;
  top: 8px;
  cursor: pointer;
  opacity: 0;
  padding-left: 32px;
}
/* .tr:hover .close {
  opacity: 1;
} */
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background-color: #eee;
}
#printBtn .ant-input {
  border-width: 0;
  background: none;
  font-size: 13px;
  color: #000;
  padding: 0;
  line-height: 32px;
}
#printBtn .ant-input:focus,
#printBtn .ant-select-selection:focus {
  border-color: #fff;
  border-right-width: 0 !important;
  outline: 0;
  box-shadow: none;
}
#printBtn .ant-input:hover,
#printBtn .ant-select-selection:hover {
  border-color: #fff;
  border-right-width: 0 !important;
}
#printBtn .ant-select-selection {
  height:31px;
  border-width: 0;
  color: #000;
}
#printBtn .ant-select {
  font-size: 13px;
  height:28px;
}
#printBtn .box-num .ant-select{
  font-size: 18px;
}
#printBtn .ant-select-selection__rendered {
  display: flex;
  justify-content: center;
  margin-left: 10px;
  height:28px;
}
#printBtn .ant-calendar-picker-icon {
  display: none;
}
.tips {
  /* margin-top: 64px; */
  padding-bottom: 32px;
  color: #999;
}
.tips p {
  margin-bottom: 0.5em;
}
.empty{
  margin-top: 32px;
}
</style>